<div class="py-dialog">
<div style="display: flex;align-items: end;flex-direction:column;">
    <button nz-button
            (click)="kapa()"
            nz-wave
            style="position: absolute;"
            [routerLink]="'/🏠/🔑'"
            nzType="primary"
            nzDanger
            nzShape="circle"
            nzSize="small"><nz-icon nzType="close" />
    </button>
</div>
<!-- <i class="close icon"></i> -->
<div class="header">
    🏷️ Etiketler
</div>

<div class="scrolling content p-3">
    <div style="display: flex; align-items: center;"
         [style.display]="saltOkunur ? 'none':'flex'">
        <input type="color" [(ngModel)]="etiketAktif.renkYazi" style="width: 2rem;padding:0" tabindex="-1">
        <input type="color" [(ngModel)]="etiketAktif.renkArka" style="width: 2rem;padding:0" tabindex="-1">


        <!-- NOT:  Ekleme Kutusu -->
        <div class="ui right labeled left icon input mini fluid"
             style="flex:1;">
            <i class="search icon"></i>
            <input type="text" placeholder="Etiket Başlığı" #inputEtiketDegeri [(ngModel)]="etiketAktif.degeri"
                    (keydown.enter)="tiklandiEtiketEkle($event)"
                    style="border-top-left-radius: 50vh;border-bottom-left-radius: 50vh;">
            <a class="ui tag blue label"
               style="border-top-right-radius: 50vh;border-bottom-right-radius: 50vh;"
               (click)="tiklandiEtiketEkle()">
                Ekle
            </a>
        </div>


        <button class="ui circular icon orange button"
                (click)="tiklandiEtiketleriYapistir();">
            <i class="clipboard icon"></i>
        </button>
        @if(etiketler.length > 2){
        <button class="ui circular icon red button"
                nz-wave
                nz-popconfirm
                nzPopconfirmTitle="Tüm Etiketler Silinecek Eminmisiniz?"
                nzOkText="Evet"
                nzCancelText="İptal"
                nzOkDanger
                (nzOnConfirm)="this.etiketler = [];CD.detectChanges()">
            <i class="trash icon"></i>
        </button>
        }
    </div>
    <!--  -->
    @if(etiketler.length > 0){
    <h4 class="ui horizontal divider header"
        style="border-bottom: 0; padding: 0;margin-top:0.5rem;">
        <i class="tag icon"></i>
        Etiket Listesi
    </h4>
    }
    <!--  -->
    <div style="margin: 1rem;">
        <!--  -->
        @for (etiket of etiketler; track etiket; let i = $index, first = $first; let l = $last, ev = $even, o = $odd;
        let co =$count){
        <a class="ui teal tag medium label"
           (click)="tiklandiEtiketSil(etiket)"
           style="margin-bottom: 0.5rem;"
           [style.color]="etiket.renkYazi"
           [style.background-color]="etiket.renkArka"
           [innerHTML]="etiket.degeri">{{etiket.degeri}}</a>
        }
        <!--  -->
    </div>

    <!-- NOT:  Kimse Bulunamadı -->
    @if(etiketler.length < 1){
      <div
      class="ui placeholder segment"
      style="margin:1rem;">
        <div class="ui icon header">
            <i class="hash tag icon"></i>
            Hiç Etiket Eklenmemiş
        </div>
        @if(!saltOkunur){
        <div class="inline">
            <div class="ui blue button"
                 (click)="inputEtiketDegeri.select();">Hemen Ekleyin</div>
        </div>
        }
</div>
}
</div>



<div class="mt-3"
     style="display: flex;align-items: end;flex-direction:row;">
    <button class="ui blue icon button mini"
            (click)="tiklandiEtiketleriKopyala()"
            style="vertical-align: top;">
        <i class="copy icon"></i>
    </button>
    <div class="ui right red labeled animated fade icon button mini"
         (click)="kapa();"
         style="vertical-align: top;">
        <div class="visible content">
            Kapat
        </div>
        <div class="hidden content">
            Kapat
        </div>
        <i class="close icon"></i>
    </div>
    <span style="flex: 1;"></span>

    @if(!saltOkunur){
    <div class="ui green labeled animated fade icon button mini"
         (click)="kaydetTiklandi()"
         *ngIf="!saltOkunur"
         style="vertical-align: top;">
        <div class="visible content">
            Kaydet
        </div>
        <div class="hidden content">
            Kaydet
        </div>
        <i class="check icon"></i>
    </div>
    }
</div>
</div>



<!-- <div class="actions">
    <button class="ui blue icon button mini"
            (click)="tiklandiEtiketleriKopyala()"
            style="vertical-align: top;">
        <i class="copy icon"></i>
    </button>
    <div class="ui right green labeled animated fade icon button mini"
         style="vertical-align: top;"
         (click)="kapa();">
        <div class="visible content">
            Kapat
        </div>
        <div class="hidden content">
            Kontrol Et!
        </div>
        <i class="send icon"></i>
    </div>

    @if(!saltOkunur){
    <div class="ui right red labeled animated fade icon button mini"
         (click)="kaydetTiklandi()"
         style="vertical-align: top;">
        <div class="visible content">
            Kaydet
        </div>
        <div class="hidden content">
            Kaydet
        </div>
        <i class="check icon"></i>
    </div>
    }
</div> -->